import { CreveLogo } from '@/components/creve/CreveLogo';
import React from 'react';

const LINK_COLUMNS = [
  {
    heading: 'Marketplace',
    links: ['Browse vendors', 'Categories', 'How it works'],
  },
  {
    heading: 'Vendors',
    links: ['Sell on Creve', 'Get verified', 'Vendor guidelines'],
  },
  {
    heading: 'Support',
    links: ['Help center', 'Report a vendor', 'Contact us'],
  },
];

export const LandingFooter: React.FC = () => {
  return (
    <footer className='border-t border-border bg-card'>
      <div className='container py-12'>
        <div className='grid gap-10 sm:grid-cols-2 lg:grid-cols-4'>
          <div>
            <CreveLogo alwaysShowWordmark />
            <p className='mt-3 max-w-xs text-sm text-muted-foreground'>
              The marketplace built for FUTO — verified vendors, real
              students, trusted transactions.
            </p>
          </div>

          {LINK_COLUMNS.map((col) => (
            <div key={col.heading}>
              <p className='font-heading text-sm font-bold text-foreground'>
                {col.heading}
              </p>
              <ul className='mt-4 space-y-2.5'>
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href='#'
                      className='text-sm text-muted-foreground transition-colors hover:text-primary'
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className='mt-12 border-t border-border pt-6 text-center text-xs text-muted-foreground'>
          &copy; {new Date().getFullYear()} Creve. Built for FUTO students, by
          FUTO students.
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
